import { createFileRoute, redirect } from '@tanstack/react-router'
import { InventoryReportsIndexScreen } from '@/features/inventory-analysis/reports-index-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/inventory/reports/')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'inventory_report.view'))
      throw redirect({ to: '/inventory' })
  },
  component: InventoryReportsIndexScreen,
})
